import { useQuery } from '@tanstack/react-query';
import { client } from '../../api';
import type { RxSearchResponse } from '../../api';
import { MIN_SEARCH_LENGTH } from '../../constants';

/**
 * Hook to search prescriptions across all tabs (except the processing tab).
 * Used for the search preview dropdown in RxTablePage.
 *
 * @param searchTerm - The search term to filter prescriptions by
 * @param enabled - Whether the query should be enabled (default: true when searchTerm has MIN_SEARCH_LENGTH+ characters)
 */
export const useSearchRx = (searchTerm: string, enabled: boolean = searchTerm.length >= MIN_SEARCH_LENGTH) => {
  return useQuery<RxSearchResponse>({
    queryKey: ['prescriptions', 'search', searchTerm],
    queryFn: () =>
      client
        .get('/rxs/search', {
          params: {
            search: searchTerm,
          },
        })
        .then((res) => res.data),
    enabled,
    // Keep previous data while fetching new results for smoother UX
    placeholderData: (previousData) => (searchTerm.length >= MIN_SEARCH_LENGTH ? previousData : undefined),
  });
};
